module.exports = __webpack_public_path__ + "static/media/dither.a5c62bfd.jpg";